import { Component, EventEmitter, OnInit, Output } from '@angular/core'

@Component({
  selector: 'app-connect-bdc-wizard-step1',
  templateUrl: './connect-bdc-wizard-step1.component.html',
  styleUrls: ['./connect-bdc-wizard-step1.component.scss'],
})
export class ConnectBDCWizardStep1Component implements OnInit {
  @Output() next = new EventEmitter()
  constructor() {}

  ngOnInit(): void {}
}
